import { Stack } from '@mui/system';

import Text from '../Text/Text';
import StyledFooterLinks from './StyledFooterLinks';
import { useTranslation } from '../../../hooks/useTranslation';

interface FooterLinksProps {
  color?: string;
  justifyContent?: string;
}

const FooterLinks: React.FC<FooterLinksProps> = ({
  color = 'var(--primary-text-color)',
  justifyContent = 'flex-start',
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 0, sm: 4 }}
      sx={{ justifyContent: justifyContent }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0, sm: 4 }}>
        <Text type="body2" color={color}>
          <StyledFooterLinks to="/privacy-policy">
            {t('Privacy Policy')}
          </StyledFooterLinks>
        </Text>
        <Text type="body2" color={color}>
          <StyledFooterLinks to="/terms-of-service">
            {t('Terms of Service')}
          </StyledFooterLinks>
        </Text>
      </Stack>
      <Text type="body2" color={color}>
        {t('Elora Call powered by Gen AI')}
      </Text>
    </Stack>
  );
};

export default FooterLinks;
